// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as actions from 'common/actions';

const flashMessages = (state = [], action) => {
  switch (action.type) {
    case actions.PUSH_FLASH_MESSAGE:
      return [...state, action.message];

    case actions.CLEAR_FLASH_MESSAGE:
      return state.filter(message => message.id !== action.id);

    default:
      return state;
  }
};

export default flashMessages;
